import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IRule } from "@models/entity-models";

@Kbo(CToken.Rule)
export class Rule extends KbObject implements IRule {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public type: string; // eRuleType
    public description: string;
    public blocks: string;
    public codeMode: boolean;
    /**
     * holds the snap workspace.  Starts with $ so angular will ignore it when parsing json
     */
    public $workspace: any;

    // public serialize(): IRule {
    //     let o = super.serialize() as IRule;
    //     if (this.$workspace) {
    //         o.blocks = this.$workspace.serializeToJson();
    //         // o.js = (new snap.Js()).generate(this.$workspace.blocks.item(0));
    //     }
    //     return o;
    // }
}
